import { DriveDetails, Hardware, HardwareType } from "../insurgo-interfaces/hardware.interface";

export class InvestigoDrive {
  databaseID: number = 0;
  driveType: 'kit' | 'swat' = 'kit';
  model: string = '';
  serialNumber: string = '';
  driveName: string = '';
  assetTag: string = '';
  dispatchReference: string = '';
  ccSentDate: Date | null = null;

  constructor(hardwareItem: Hardware) {
    if (hardwareItem.HardwareTypeID === HardwareType.KIT_DRIVE) {
      this.driveType = 'kit';
    } else if (hardwareItem.HardwareTypeID === HardwareType.SWAT_DRIVE) {
      this.driveType = 'swat';
    }
    this.serialNumber = hardwareItem.SerialNumber;
    this.assetTag = hardwareItem.AssetTag;
    this.databaseID = hardwareItem.HardwareRegisterID;
    this.model = hardwareItem.OtherDetails.model;

    const ccSentDateSec = hardwareItem.CCSentDateSec as number;
    if (ccSentDateSec) {
      this.ccSentDate = new Date(ccSentDateSec * 1000);
    } else {
      this.ccSentDate = null;
    }

    if ('driveName' in hardwareItem.OtherDetails) {
      this.driveName = hardwareItem.OtherDetails.driveName as string;
    }
    if ('dispatchReference' in hardwareItem.OtherDetails) {
      this.dispatchReference = hardwareItem.OtherDetails.dispatchReference as string;
    }

  }

}